import { Checkbox } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { ConfigValueInputProps } from "./";

interface BoolConfigValueInputProps extends ConfigValueInputProps {}

export const BoolConfigValueInput = ({
  value,
  onUpdate,
  isReadOnly
}: BoolConfigValueInputProps) => {
  const boolValue = value === "true";
  const boolUpdate = (value: boolean | undefined) => {
    onUpdate(value ? "true" : "false");
  };

  const { data: hasDeployPermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementDeploy
  );

  return (
    <Checkbox
      checked={boolValue}
      onChange={(e, value) => boolUpdate(value)}
      automationAttribute="bool-config-input"
      disabled={isReadOnly || !hasDeployPermission}
      title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
    />
  );
};
